import FetchDeviceVulnerability from './DeviceVulnerability';

export default FetchDeviceVulnerability;
